import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { CategoryAction } from '../../../../redux/Action/ProfileAction';

const CategoryItem = ({ handleSelectedCategory, categoryError, watch }: any) => {
    const dispatch = useDispatch<any>();
    const categoryData = useSelector((state: any) => state.CategoryState);

    const [Category, setCategory]: any = useState([]);
    const [selectedCategoryId, setSelectedCategoryId]: any = useState(null);

    useEffect(() => {
        dispatch(CategoryAction({}))
    }, []);

    useEffect(() => {
        if (watch("category")) {
            setSelectedCategoryId(watch("category") ? watch("category") : null)
        }
    }, [watch("category")]);

    useEffect(() => {
        if (categoryData?.data?.data?.categories?.length) {
            setCategory(categoryData?.data?.data)
        }
    }, [categoryData]);

    const handleCheckboxChange = (id: any) => {
        setSelectedCategoryId((prevSelectedCategoryId: any) => {
            return prevSelectedCategoryId === id ? null : id;
        });
    };

    useEffect(() => {
        handleSelectedCategory(selectedCategoryId)
    }, [selectedCategoryId]);

    return (
        <>
            <div className='category'>
                <ul>
                    {
                        Category?.categories?.length > 0 && Category?.categories?.map((item: any, index: any) => {
                            return (
                                item?.category_detail && (
                                    <li key={index}>
                                        <input
                                            type="checkbox"
                                            className="btn-check"
                                            id={`option-${index}`}
                                            checked={selectedCategoryId === item?.category_detail?.id}
                                            onChange={() => handleCheckboxChange(item?.category_detail?.id)}
                                        />
                                        <label htmlFor={`option-${index}`}>
                                            <figure>
                                                <img

                                                    onError={(e: any) => e.target.src = "images/fely-beauty.jpg"}
                                                    src={item?.category_detail?.image_details?.file_path}
                                                    alt={`Category ${index}`}
                                                />
                                                <span className="icon-check"></span>
                                            </figure>
                                            <p>{item?.category_detail?.name}</p>
                                        </label>
                                    </li>
                                )
                            )
                        })
                    }
                </ul>
            </div>
        </>
    );
}

export default React.memo(CategoryItem);
